import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "Accordion View Config"})
export default class AccordionViewConfig {

	@Input({type: InputType.CHECKBOX, title: "wat"})
	public test: boolean;

}



// WEBPACK FOOTER //
// ./src/common/views/accordion/AccordionViewConfig.ts